export default __webpack_public_path__ + "static/media/con-offline.bd1c8e21.svg";